module.exports = __webpack_public_path__ + "img/square-up-left.5733c64d.svg";